import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { motion, AnimatePresence } from 'framer-motion';
interface CountdownProps {
  compact?: boolean;
}
export function Countdown({
  compact = false
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  if (compact) {
    return <div className="flex items-center gap-1 font-mono text-sm font-bold text-ember" data-id="element-52">
        <span data-id="element-53">{hours}</span>:<span data-id="element-54">{minutes}</span>:
        <div className="relative w-4 h-5 overflow-hidden inline-block align-bottom" data-id="element-55">
          <AnimatePresence mode="popLayout" data-id="element-56">
            <motion.span key={seconds} initial={{
            y: 20,
            opacity: 0
          }} animate={{
            y: 0,
            opacity: 1
          }} exit={{
            y: -20,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} className="absolute inset-0 flex items-center justify-center" data-id="element-57">
              {seconds}
            </motion.span>
          </AnimatePresence>
        </div>
      </div>;
  }
  return <div className="flex items-center justify-center gap-2 md:gap-4 font-serif text-4xl md:text-6xl font-bold text-charcoal tracking-tight" data-id="element-58">
      <div className="flex flex-col items-center bg-white px-4 py-2 rounded-lg shadow-sm border border-sand" data-id="element-59">
        <span data-id="element-60">{hours}</span>
        <span className="text-xs font-sans font-medium text-gray-500 uppercase tracking-widest mt-1" data-id="element-61">
          HS
        </span>
      </div>
      <span className="text-ember pb-6" data-id="element-62">:</span>
      <div className="flex flex-col items-center bg-white px-4 py-2 rounded-lg shadow-sm border border-sand" data-id="element-63">
        <span data-id="element-64">{minutes}</span>
        <span className="text-xs font-sans font-medium text-gray-500 uppercase tracking-widest mt-1" data-id="element-65">
          MIN
        </span>
      </div>
      <span className="text-ember pb-6" data-id="element-66">:</span>
      <div className="flex flex-col items-center bg-white px-4 py-2 rounded-lg shadow-sm border border-sand overflow-hidden relative" data-id="element-67">
        <div className="relative h-[40px] md:h-[60px] w-[45px] md:w-[65px]" data-id="element-68">
          <AnimatePresence mode="popLayout" data-id="element-69">
            <motion.span key={seconds} initial={{
            y: 40,
            opacity: 0
          }} animate={{
            y: 0,
            opacity: 1
          }} exit={{
            y: -40,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} className="absolute inset-0 flex items-center justify-center" data-id="element-70">
              {seconds}
            </motion.span>
          </AnimatePresence>
        </div>
        <span className="text-xs font-sans font-medium text-gray-500 uppercase tracking-widest mt-1" data-id="element-71">
          SEG
        </span>
      </div>
    </div>;
}